export function getJournalYearRange(journal) {
  const currentYear = new Date().getFullYear();

  // Default range if no journal is specified
  if (!journal) {
    return {
      minYear: 1947,
      maxYear: currentYear,
    };
  }

  const journalRanges = {
    CLC: { minYear: 1962, maxYear: 2025 },
    CLCN: { minYear: 2016, maxYear: 2020 },
    CLD: { minYear: 2000, maxYear: 2024 },
    CLR: { minYear: 1970, maxYear: 2024 },
    FSC: { minYear: 2009, maxYear: 2024 },
    GBLR: { minYear: 2010, maxYear: 2016 },
    KLR: { minYear: 1900, maxYear: 2022 },
    LHC: { minYear: 1970, maxYear: 2025 },
    MLD: { minYear: 1963, maxYear: 2024 },
    NLR: { minYear: 1968, maxYear: 2016 },
    PCRLJ: { minYear: 1954, maxYear: 2024 },
    PCRLJN: { minYear: 2016, maxYear: 2023 },
    PCTLR: { minYear: 1970, maxYear: 2023 },
    PCrLJ: { minYear: 1968, maxYear: 2018 },
    PLC: { minYear: 1957, maxYear: 2024 },
    "PLC(CS)": { minYear: 1970, maxYear: 2024 },
    "PLC(CS)N": { minYear: 2017, maxYear: 2023 },
    PLCN: { minYear: 2017, maxYear: 2018 },
    PLD: { minYear: 1916, maxYear: 2025 },
    PLJ: { minYear: 1970, maxYear: 2024 },
    PSC: { minYear: 1984, maxYear: 2023 },
    "PSC CRI": { minYear: 1987, maxYear: 2023 },
    PTCL: { minYear: 1960, maxYear: 2024 },
    PTD: { minYear: 1951, maxYear: 2024 },
    SBLR: { minYear: 2001, maxYear: 2016 },
    SCMR: { minYear: 1966, maxYear: 2024 },
    SCP: { minYear: 1970, maxYear: 2025 },
    SCR: { minYear: 1989, maxYear: 2017 },
    SD: { minYear: 1985, maxYear: 2016 },
    TAX: { minYear: 1952, maxYear: 2016 },
    YLP: { minYear: 2011, maxYear: 2020 },
    YLR: { minYear: 1999, maxYear: 2024 },
    YLRN: { minYear: 2016, maxYear: 2023 },
  };

  return (
    journalRanges[journal] || {
      minYear: 1947,
      maxYear: currentYear,
    }
  );
}
